export default {
  global: {
    select: 'Seleziona',
    warning: 'Attenzione!',
    ok: 'Ok',
    cancel: 'Annulla',
    confirm: 'Conferma',
    add: 'Aggiungi',
    actions: 'Azioni',
    success: 'Operazione completata con successo',
    error: 'Errore',
    serverError: 'Errore, riprova più tardi',
    laboratory: 'Laboratorio',
    noPermissonRoute: 'Non hai i permessi per accedere a questa sezione',
    pagination: 'Paginazione:',
    paginationEnable: 'Sì',
    paginationDisable: 'No',
    close: 'Chiudi',
    openAsTab: 'Apri tab',
    update: 'Aggiornamento',
    next: 'Prossimo',
    prev: 'Precedente',
    confirmAction: 'Sei sicuro di voler procedere?',
    back: 'Indietro',
    analysisNumber: 'N° {number}',
    clipboard: {
      copied: 'Copiato negli appunti',
      copyFailed: 'Copia negli appunti non riuscita',
    },
  },
  table: {
    massiveActions: {
      title: 'Applica a tutti',
      submit: 'Applica',
    },
    columnsConfig: {
      stickyHint:
        'Usa la puntina per bloccare una colonna a sinistra durante lo scroll orizzontale (max {max}).',
      pin: 'Blocca colonna a sinistra',
      unpin: 'Sblocca colonna',
    },
  },
  menuItems: {
    baseArchives: 'Archivi di base',
    offers: 'Riepilogo Offerte',
    offersManagement: 'Riepilogo Offerte',
    thermostatsManagement: 'Anagrafica termostati',
    operations: 'Anagrafica operazioni',
    sampleManagement: 'Gestione campioni',
    receivedSamplesIndex: 'Ricevimento campioni',
    workPlanning: 'Etichette/Programma di lavoro',
    quarantineIndex: 'Quarantena',
    analysisManagement: 'Gestione analisi',
    insertAnalysesDataIndex: 'Inserimento dati analisi',
    analysisStatusManagementIndex: 'Gestione status analisi',
    analysisWorkPlanning: 'Programma di lavoro',
    printAnalysisReport: 'Stampa rapporto di prova',
    printAnalyses: 'Stampa elenco analisi',
    analysesSearch: 'Ricerca',
    configuration: 'Configurazione',
    usersManagement: 'Gestione utenti',
    rolesManagement: 'Gestione ruoli',
    signatureConfig: 'Firma rapporto di prova',
    groupingInfo: 'Informazioni raggruppamenti',
    changeLog: 'Lista modifiche',
    tasksIndex: 'Attività',
    systemConfig: 'Sistema',
    signatureRecipientsIndex: 'Gruppi di firma',
    documents: 'Documenti',
    signDocuments: 'Firma documenti',
    signatureProfilesIndex: 'Profili di firma',
    approvalCustomerChangesIndex: 'Approvazione modifiche cliente',
    locations: 'Gestione sedi',
    locationsManagementIndex: 'Anagrafica sedi',
    sectorsAssociation: 'Associazione settori',
    defaultLocations: 'Associazione analisi',
    customersLocationsManagement: 'Associazione clienti',
    customerSampleAnalysesIndex: 'Assegnazione sede',
    familyTypesIndex: 'Configurazione template RdP',
    familyCategoriesIndex: 'Categorie famiglie',
    uploadDocument: 'Caricamento PDF da firmare',
    analysesThermostatsSearchIndex: 'Ricerca termostati analisi',
    symbolSearchIndex: 'Ricerca medium analisi',
    stability: 'Stabilità',
    stabilityConfigurationsIndex: 'Configurazioni Stabilità',
    stabilityScheduleIndex: 'Scadenziario',
    stabilityTimePointExportIndex: 'Estrazione T',
    advancedTools: 'Strumenti avanzati',
    advancedRevisionIndex: 'Revisione avanzata',
    monitoringDashboard: 'Monitoraggio Scadenze',
    monitoringDashboardAcceptance: 'In attesa di accettazione',
    monitoringDashboardExpiring: 'Scadenze',
    monitoringDashboardProcessing: 'In attesa di lavorazione',
    monitoringDashboardToComplete: 'Da completare',
  },
  monitoringDashboard: {
    title: 'Monitoraggio Scadenze',
    refresh: 'Aggiorna',
    subtitle: 'Vista rapida delle attività urgenti',
    refreshAll: 'Aggiorna',
    clearFilters: 'Svuota filtri',
    export: 'Esporta Excel',
    exportNoDetail:
      'Apri il dettaglio campioni cliccando su un valore per poter esportare',
    clickHint: 'Clicca su un numero per aprire il dettaglio dei campioni',
    empty: 'Nessun dato da mostrare',
    filters: {
      sede: 'Sede',
      reparto: 'Reparto',
      sedePlaceholder: 'Seleziona sede',
      repartoPlaceholder: 'Seleziona reparto',
      clientePlaceholder: 'Digita almeno 3 caratteri',
      columnFilters: 'Filtri colonne',
    },
    stati: {
      accepted: 'Accettato',
      inprogress: 'In lavorazione',
      tobeverified: 'Da verificare',
      tobeapproved: 'Da approvare',
      completedunsigned: 'Completato non firmato',
      tbv: 'Da verificare',
      tba: 'Da approvare',
      tbs: 'Da firmare',
    },
    family: {
      laboratory: 'Reparto',
      familycode: 'Famiglia',
      families: 'Famiglie',
      total: 'Totale',
      unknownFamily: 'N/D',
    },
    detail: {
      title: 'Dettaglio campioni',
      close: 'Chiudi',
      empty: 'Nessun campione',
      columns: {
        orderId: 'ID ordine',
        groupingId: 'ID raggruppamento',
        labSampleCode: 'Cod. campione',
        status: 'Stato',
        customerId: 'ID cliente',
        customerName: 'Nome cliente',
        location: 'Sede',
        laboratory: 'Reparto',
        customer: 'Cliente',
        productName: 'Prodotto',
        customerProductName: 'Cod. campione cliente',
        deliveryDate: 'Data presunta consegna',
        acceptanceDate: 'Data ordine cliente',
        acceptedAt: 'Data accettazione',
        daysWaiting: 'Giorni in attesa',
      },
      analyses: {
        empty: 'Nessuna analisi',
        columns: {
          code: 'Cod. analisi',
          description: 'Descrizione analisi',
          methodCode: 'Cod. metodo',
          status: 'Stato analisi',
        },
      },
    },
    toComplete: {
      title: 'Da completare',
      subtitle: 'Analisi da completare',
      empty: 'Nessuna analisi da completare',
      beforeSearch:
        'Imposta la data di accettazione e premi Aggiorna per vedere i risultati',
      export: 'Esporta Excel',
      multiAnalysisNote: 'Un campione con più analisi compare su più righe.',
      card: {
        title: 'Da completare',
        total: 'Tot. campioni da completare',
        expired: 'Campioni scaduti',
        openDetail: 'Apri elenco',
      },
      notes: {
        selected: 'righe selezionate',
        assign: 'Assegna nota',
        dialogTitle: 'Assegna nota',
        affectedRows:
          'La nota sarà applicata a {count} righe selezionate, sostituendo le note già presenti.',
        label: 'Nota',
        placeholder: 'Scrivi la nota',
        confirm: 'Salva',
        cancel: 'Annulla',
        saved: 'Nota salvata',
        cleared: 'Nota rimossa',
        tooManyRows:
          'Selezione troppo ampia: massimo {limit} righe per salvataggio. Riduci la selezione.',
        confirmClearTitle: 'Cancella note',
        confirmClear:
          'Il testo è vuoto: le note verranno cancellate su {count} righe selezionate. Confermi?',
        updatedBy: 'Aggiornata da',
        updatedAt: 'Ultimo aggiornamento',
      },
      filters: {
        search: 'Cerca',
        clear: 'Svuota filtri',
        showParents: 'Mostra analisi padre',
        showUnsignedRevisions: 'Mostra anche revisioni non firmate',
        pendingRevision: {
          yes: 'Sì',
          no: 'No',
        },
        stability: {
          label: 'Stabilità',
        },
        operators: {
          '=': 'Uguale a',
          lte: 'Scadute da più di',
          gte: 'Mancano almeno',
        },
      },
      columns: {
        laboratory: 'Reparto',
        location: 'Sede',
        customerName: 'Cliente',
        offerDocNumber: 'Cod. offerta',
        orderId: 'ID ordine',
        orderSentAt: 'Data invio ordine',
        groupingId: 'ID raggruppamento',
        labSampleCode: 'Cod. campione',
        acceptedAt: 'Data accettazione',
        labSampleStatus: 'Stato campione',
        isPendingRevision: 'In revisione',
        analysisDescription: 'Descrizione analisi',
        analysisCode: 'Cod. articolo',
        analysisMethod: 'Metodo',
        analysisStart: 'Inizio analisi',
        analysisEnd: 'Fine analisi',
        analysisStatus: 'Stato analisi',
        expectedDeliveryDate: 'Prevista consegna',
        daysRemaining: 'Giorni rimanenti',
        note: 'Note',
      },
    },
    blocks: {
      acceptance: {
        title: 'In attesa di accettazione',
        buckets: {
          twoDays: '2 giorni',
          threeToFiveDays: '3-5 giorni',
          moreThanFiveDays: '> 5 giorni',
        },
      },
      expired: {
        title: 'Scaduti',
      },
      closing: {
        title: 'In scadenza da chiudere',
        buckets: {
          today: 'Oggi',
          tomorrow: 'Domani',
          dayAfterTomorrow: 'Dopodomani',
        },
      },
      toBeProcessed: {
        title: 'In attesa di lavorazione',
        matrixTitle: 'Dettaglio per reparto e famiglia',
        multiFamilyNote:
          'Un campione con più famiglie compare in più righe: i totali della matrice possono superare il numero di campioni distinti. I KPI in alto contano ogni campione una sola volta.',
        kpis: {
          totalAccepted: 'Tot. campioni accettati',
          backlogOver10: 'Oltre 10g',
          departmentsInvolved: 'Reparti coinvolti',
        },
        buckets: {
          oneDay: '1 giorno',
          twoToThreeDays: '2-3 giorni',
          fourToFiveDays: '4-5 giorni',
          sixToTenDays: '6-10 giorni',
          moreThanTenDays: '> 10 giorni',
        },
      },
    },
  },
  advancedRevision: {
    title: 'Revisione avanzata',
    wizard: {
      title: 'Revisione Avanzata',
      next: 'Avanti',
      back: 'Indietro',
      close: 'Chiudi',
      success: 'Revisione creata con successo',
      submitError: 'Errore durante la creazione della revisione',
      loadError: 'Errore durante il caricamento dei dati del campione',
      requiredReason:
        'Tipo di errore, note errore e note interne sono obbligatori',
      steps: {
        reason: 'Revisione',
        sample: 'Campione',
        analyses: 'Analisi',
        temperature: 'Tracce temperatura',
      },
      errorType: 'Tipo di intervento',
      errorTypes: {
        own: 'Errore Complife',
        client: 'Richiesta cliente',
        correction: 'Correzione pre-firma',
        other: 'Altro',
      },
      errorNotes: 'Note errore',
      internalNotes: 'Note interne',
      toBeInvoiced: 'Da fatturare',
      sampleAnalysisStart: 'Inizio analisi',
      sampleAnalysisEnd: 'Fine analisi',
      acceptedAt: 'Data accettazione',
      lastReportDate: 'Data ultimo report',
      productCode: 'Codice prodotto',
      productName: 'Nome prodotto',
      lot: 'Lotto',
      sector: 'Settore',
      sampleDescription: 'Descrizione campione',
      packagesNumber: 'Numero confezioni',
      finalCustomer: 'Cliente finale',
      samplingInfo: 'Informazioni di campionamento',
      samplingDate: 'Data campionamento',
      samplingPlan: 'Piano di campionamento',
      samplingPlace: 'Luogo di campionamento',
      samplingMethod: 'Metodo di campionamento',
      sampledBy: 'Campionato da',
      validValue: 'Valore valido',
      accredited: 'Accreditato',
      reportAccredited: 'Report accreditato',
      dilution: 'Diluizione',
      methodCode: 'Metodo',
      locationId: 'Sito di svolgimento',
      analysisTranslationIt: 'Descrizione analisi (IT)',
      analysisTranslationEn: 'Descrizione analisi (EN)',
      terrains: 'Diluenti e terreni',
      medium: 'Medium',
      mediumType: 'Tipo medium',
      lotNumber: 'Lotto',
      temperature: 'Temperatura',
      startedAt: 'Inizio',
      endedAt: 'Fine',
      thermostatName: 'Termostato',
      analysis: 'Analisi',
      addTrail: 'Aggiungi',
      deleteTrail: 'Elimina traccia',
      deleteTrailConfirm: "Confermi l'eliminazione della traccia?",
      deleteTrailConfirmTitle: 'Elimina traccia',
      trailAdded: 'Traccia aggiunta con successo',
      trailDeleted: 'Traccia eliminata con successo',
      trailError: "Errore durante l'operazione sulla traccia",
    },
    actions: {
      viewReport: 'Visualizza Rapporti di prova',
      review: 'Revisione avanzata',
      preSignEdit: 'Modifica avanzata pre-firma',
    },
  },
  filters: {
    role: 'Ruolo',
    roles: 'Ruoli',
    laboratory: 'Laboratorio',
    laboratories: 'Laboratori',
    email: 'Email',
    emails: 'Email',
    activeInactive: 'Attivo / Disattivato',
    active: 'Attivo',
    inactive: 'Disattivato',
    search: 'Cerca',
    clearFilter: 'Svuota filtri',
    isEnabled: 'Attivo',
    actions: 'Azioni',
    username: 'Username',
    name: 'Nome',
    permissionsCount: 'Permessi attivi',
    sequence: 'Sequenza',
    operation: 'Operazione',
    containerType: 'Contenitore',
    symbol: 'Medium',
    symbolType: 'Tipo medium',
    containerCount: 'Numeri contenitore',
    expectedValue: 'Valore atteso',
    LD: 'LD',
    LQ: 'LQ',
    U: 'U',
    infLimit: 'Limite inferiore',
    supLimit: 'Limite superiore',
    printOnWorksheet: 'Stampa su programma di lavoro',
    printOnLabels: 'Stampa su etichette',
    mainResult: 'Risultato Principale',
    customer: 'Cliente',
    customerIdOrName: 'Cliente Id / Nome',
    orderDate: 'Data ordine cliente',
    sampleName: 'Nome campione',
    orderNumber: 'Numero ordine',
    batch: 'Lotto',
    toBeAcceptedRefused: 'Da Accettare / Rifiutato',
    toBeAccepted: 'Da Accettare',
    refused: 'Rifiutato',
    groupCode: 'Codice raggruppamento',
    updatedAt: 'Aggiornato il',
    labSampleCode: 'Codice prodotto',
    productCode: 'Codice prodotto',
    productName: 'Nome prodotto',
    customerSampleCode: 'Codice campione cliente',
    sampleId: 'Codice campione',
    labSampleId: 'Codice campione',
    labSampleIds: 'Codici laboratorio',
    lot: 'Lotto',
    lotDate: 'Data lotto',
    sector: 'Settore',
    packagesNumber: 'Numero campioni',
    customerNotes: 'Note del cliente',
    finalCustomer: 'Cliente finale',
    finalCustomerRef: 'Riferimento Cliente finale',
    sampleDescription: 'Descrizione campione',
    sampleInstructions: 'Istruzioni testuali',
    samplingInfo: 'Informazioni di campionamento',
    plan: 'Piano di campionamento',
    place: 'Luogo di campionamento',
    method: 'Metodo di campionamento',
    sampledBy: 'Campionato da',
    costCenter: 'Centro di costo cliente',
    rejectReason: 'Motivazione rifiuto',
    actionReason: 'Motivazione azione',
    quarantineComment: 'Motivazione quarantena',
    quarantineReason: 'Ragione',
    quarantineSource: 'Provenienza',
    status: 'Status',
    analysisStatus: 'Stato analisi',
    stability: {
      name: 'Nome',
      createdAt: 'Creato il',
      configuredAt: 'Configurato il',
      configuredBy: 'Configurato da',
      timePoints: 'Punti Temporali',
      docNumber: 'Numero offerta',
      productName: 'Nome prodotto',
      analysisCode: 'Cod. articolo',
      analysisDescription: 'Descrizione',
    },
    stabilityToken: 'Token Stabilità',
    stabilityFilter: 'Stabilità',
    stabilityTemperatureHumidity: 'Temperatura-Umidità',
    stabilityMatrix: 'Matrice',
    customerId: 'Codice cliente',
    grouping: 'Raggruppamento',
    year: 'Anno',
    hasValues: 'Valori inseriti',
    viewOnlyValues: 'Vedi solo inseriti',
    viewAll: 'Vedi tutti',
    customerName: 'Ragione sociale',
    receivedDate: 'Data accettazione',
    startDate: 'Data inizio',
    endDate: 'Data fine',
    createdAt: 'Data creazione',
    analysisCode: 'Codice',
    parentAnalysisCode: 'Analisi padre',
    analysisDescription: 'Descrizione',
    analysisDescriptionFull: 'Descrizione analisi',
    analysisMethod: 'Metodo',
    analysisMeasure: 'Unità di misura',
    customerProductName: 'Codice Campione cliente',
    orderId: 'ID Ordine',
    analysisStart: 'Data inizio',
    analysisEnd: 'Data fine',
    sampleAnalysisStart: 'Inizio analisi',
    sampleAnalysisEnd: 'Fine analisi',
    samplesCount: 'Totale campioni',
    value: 'Valore rilevato',
    latestPrint: 'Ultima stampa',
    orderName: 'Nome Ordine',
    measure: 'Unità di misura',
    operationMeasure: 'UdM Operazione',
    valueMeasure: 'UdM Valore',
    overrideValues: 'Valori',
    notes: 'Note',
    id: 'Id',
    currentTemperature: 'Temperatura corrente',
    enabled: 'Attivo',
    department: 'Reparto',
    thermostat: 'Termostato',
    temperature: 'Temperatura',
    dilution: 'Diluizione',
    startedAt: 'Data inizio',
    endedAt: 'Data fine',
    thermostatId: 'Identificativo termostato',
    thermostatName: 'Nome termostato',
    docNumber: 'Numero documento',
    issuedAt: 'Data documento',
    expirationDate: 'Data fine validità',
    price: 'Importo',
    type: 'Tipologia',
    offerEnabled: 'Attiva',
    offerRemaining: 'Analisi rimanenti',
    usedAnalysis: 'Analisi utilizzate',
    taskType: 'Tipologia',
    started: 'Iniziato',
    completed: 'Completato',
    rolesCount: 'Ruoli',
    isSigned: 'Firmato',
    signedAt: 'Data firma',
    signedBy: 'Firmato da',
    documentType: 'Tipo documento',
    certificateExpiration: 'Data scadenza',
    activatedAt: 'Data attivazione',
    showRawData: 'Anticipo risultati',
    requestedAt: 'Data richiesta',
    date: 'Data',
    comments: 'Istruzioni testuali',
    lastError: 'Ultimo errore',
    description: 'Descrizione',
    code: 'Codice',
    locationIdOrName: 'Sede Id / Nome',
    location: 'Sede',
    motivation: 'Descrizione',
    legalConstraint: 'Vincoli normativi',
    customerSampleId: 'Id campione cliente',
    progressive: 'Numero progressivo',
    familyCode: 'Codice famiglia',
    family: 'Famiglia',
    recoveryFactor: 'Fattore di recupero',
    specification: 'Specifica',
    specificationType: 'Tipo specifica',
    customerProductCode: 'Codice prodotto',
    expectedDeliveryDate: 'Data prevista consegna',
    approvalUser: 'Utente approvazione',
    ipAddress: 'Indirizzo IP',
    articleCodes: 'Codici articolo',
    articleDescriptions: 'Descrizioni articolo',
    timestampChange: 'Ultima modifica',
    sampleTimestampChange: 'Data modifica campione',
    entityName: 'Nome entità',
    userName: 'Nome utente',
    userId: 'Utente Id',
    hostname: 'Hostname',
    labSampleAnalysisId: 'Codice analisi campione di laboratorio',
    operationRegistryId: 'Codice operazione',
    measureId: 'Codice unità di misura',
    validValue: 'Valore valido',
    analysisId: 'Codice analisi',
    selectionValues: 'Valori selezionati',
    specificationValue: 'Valore di specifica',
    decimalDigits: 'Cifre decimali',
    minRange: 'Valore minimo',
    maxRange: 'Valore massimo',
    isMinRangeInclusive: 'Valore minimo incluso',
    isMaxRangeInclusive: 'Valore massimo inclso',
    freeTextValue: 'Valore testo libero',
    reason: 'Ragione',
    source: 'Provenienza',
    symbolLot: 'Lotto simbolo',
    permissions: 'Permessi',
    locationId: 'Sede Id',
    changeType: 'Tipo modifica',
    openTrails: 'Tracce aperte',
    hasLocation: 'Stato sede',
    quarantineDate: 'Data quarantena',
    temperatureTrailId: 'Traccia Temperatura Id',
    data: 'Dati Attività',
    displayTitle: 'Titolo sul rapporto di prova',
    customerComments: 'Commenti',
    revision: 'Revisione',
    reportStatus: 'Stato RdP',
    acceptedAt: 'Data accettazione',
    lastReportDate: 'Data ultimo report',
    analysisNotes: 'Note analisi',
    labNotes: 'Note di laboratorio',
    errorType: 'Tipo di intervento',
    errorCause: 'Causa errore',
    errorNotes: 'Note errore',
    internalNotes: 'Note interne',
    toBeInvoiced: 'Da fatturare',
    addressId: 'Indirizzo Id',
    customerAddress: 'Indirizzo cliente',
    advancedReviewFilter: 'Revisione avanzata',
    reportCode: 'Codice RdP',
    documentId: 'Id documento',
    reportEmittedDate: 'Data emissione report',
    accredited: 'Report accreditato',
    sampleReportStatus: 'Status report',
    customerOrderNumber: 'Numero ordine cliente',
  },
  tableButtons: {
    editUser: 'Modifica',
    disableUser: 'Disabilita',
    enableUser: 'Abilita',
    editUserLab: 'Modifica laboratorio',
    editUserRole: 'Modifica ruolo',
    editRole: 'Modifica ruolo',
    showUsers: 'Mostra utenti',
    editOperation: 'Modifica operazione',
    deleteOperation: 'Elimina operazione',
    accept: 'Accetta',
    refuse: 'Rifiuta',
    downloadAttachments: 'Scarica allegati',
    downloadDetails: 'Scarica dettagli',
    downloadAttachment: 'Scarica allegato',
    quarantine: 'Quarantena',
    edit: 'Modifica',
    delete: 'Elimina',
    clone: 'Clona',
    insertExpectedValues: 'Inserisci valori attesi',
    viewAnalysesDetails: 'Visualizza dettagli analisi',
    insertMeasuredValue: 'Inserisci valore rilevato',
    insertMeasuredValueBulk:
      'Inserisci valori rilevati per tutte le operazioni',
    changeGroupingStatus: 'Cambia stato raggruppamento',
    changeSampleStatus: 'Cambia stato campione',
    sampleDraft: 'Abilita status draft',
    removeSampleDraft: 'Termina status draft',
    printSample: 'Stampa',
    createSampleRevision: 'Crea revisione',
    renameSample: 'Modifica campione',
    enableRawData: 'Abilita anticipo risultati',
    disableRawData: 'Disabilita anticipo risultati',
    groupingInfo: 'Informazioni raggruppamento',
    proceedLocked: 'Campione parte di un ordine bloccato',
    reportLocked: 'Report bloccati',
    askApproval: 'Richiedi approvazione',
    showComment: 'Mostra commenti',
    viewReports: 'Rapporti di prova',
    viewReport: 'Rapporti di prova',
    advancedRevision: 'Revisione avanzata',
    downloadTestReport: 'Scarica rapporto di prova',
    editThermostat: 'Modifica termostato',
    editTemperature: 'Modifica temperatura',
    showTempsHistory: 'Visualizza storico temperature',
    changeDilution: 'Cambia diluizione',
    createTemperatureTrail: 'Traccia temperatura',
    showDetail: 'Mostra dettagli',
    editRecipientGroup: 'Modifica gruppo',
    deleteRecipientGroup: 'Elimina gruppo',
    viewDocumentPdf: 'Visualizza PDF',
    signDocument: 'Firma documento',
    downloadSignedPdf: 'Scarica PDF firmato',
    updateCredentials: 'Aggiorna Credenziali',
    viewDiff: 'Visualizza modifiche',
    editLocation: 'Modifica sede',
    disableLocation: 'Disabilita sede',
    editSector: 'Modifica settore',
    deleteSector: 'Elimina settore',
    deleteLocation: 'Elimina sede',
    editCustomerLocation: 'Modifica associazione',
    deleteCustomerLocation: 'Elimina associazione',
    associateLocation: 'Associa sede',
    cancelAnalysis: 'Annulla analisi',
    editFamilyType: 'Modifica configurazione',
    uploadDocument: 'Importa documento esterno',
    removeUploadedReport: 'Rimuovi relazione',
    editSamplingInformation: 'Modifica informazioni campionamento',
    editSpecification: 'Modifica specifica',
    deleteSpecification: 'Elimina specifica',
    addCustomSpecification: 'Aggiungi specifica custom',
    viewChangelogDetails: 'Visualizza dettaglio',
    unlockUser: 'Sblocca',
    editLabNotes: 'Modifica nota campione',
    createLabNotes: 'Crea nota campione',
    viewLabNotes: 'Visualizza nota campione',
    restart: 'Riavvia',
    configure: 'Configura',
    show: 'Visualizza',
    retry: 'Riprova',
  },
  constants: {
    DEFAULT: 'Default',
    CHIM: 'Chimico',
    // MICRO: 'Micro',
    MICR: 'Microbiologico',
    META: 'Tutti',
    TestReport: 'Rapporto di Prova',
    active: 'Attivo',
    waiting: 'In attesa',
    expired: 'Scaduto',
  },
  permissions: {
    rolesManagement: 'Gestione ruoli',
    rolesView: 'Visualizzazione',
    rolesManage: 'Gestione',
    usersManagement: 'Gestione utenti',
    usersView: 'Visualizzazione',
    usersManage: 'Gestione',
    operations: 'Anagrafica operazioni',
    operationsView: 'Visualizzazione',
    operationsManage: 'Gestione',
    receivedSamples: 'Ricevimento campioni',
    receivedSamplesView: 'Visualizzazione',
    receivedSamplesDownload: 'Download',
    receivedSamplesManage: 'Gestione',
    workPlanning: 'Etichette / Programma di lavoro',
    workPlanningManage: 'Gestione',
    quarantine: 'Quarantena',
    quarantineView: 'Visualizzazione',
    quarantineManage: 'Gestione',
    analysesData: 'Inserimento dati analisi',
    analysesDataView: 'Visualizzazione',
    analysesDataManage: 'Gestione',
    analysisImportMapping: 'Associazioni colonne import da file',
    analysisImportMappingView: 'Visualizzazione',
    analysisImportMappingManage: 'Gestione',
    analysesStatus: 'Gestione status analisi',
    analysesStatusView: 'Visualizzazione',
    analysesStatusManage: 'Gestione',
    analysesWorkPlanning: 'Programma di lavoro analisi',
    analysesWorkPlanningView: 'Visualizzazione',
    analysesWorkPlanningManage: 'Gestione',
    printReport: 'Stampa rapporto di prova',
    printReportManage: 'Gestione',
    printAnalyses: 'Stampa elenco analisi',
    printAnalysesManage: 'Gestione',
    search: 'Ricerca',
    searchManage: 'Gestione',
    changelog: 'Lista modifiche',
    changelogView: 'Visualizzazione',
    thermostats: 'Gestione termostati',
    thermostatsView: 'Visualizzazione',
    thermostatsManage: 'Gestione',
    analysisDataTemperature: 'Gestione temperatura incubazione',
    analysisDataTemperatureView: 'Visualizzazione',
    analysisDataTemperatureManage: 'Gestione',
    terrainDiluentLot: 'Gestione lotto terreni e diluenti',
    terrainDiluentLotView: 'Visualizzazione',
    terrainDiluentLotManage: 'Gestione',
    systemAdministration: 'Amministrazione sistema',
    signature: 'Firma digitale',
    signatureUser: 'Firma documenti',
    signatureManage: 'Gestione',
    locationsManagement: 'Gestione sedi',
    locationsView: 'Visualizzazione',
    locationsManage: 'Gestione',
    analysisLocations: 'Associazione analisi - sede',
    analysisLocationView: 'Visualizzazione',
    analysisLocationsManage: 'Gestione',
    locationSectorDepartment: 'Associazione settore - sede',
    locationSectorDepartmentView: 'Visualizzazione',
    locationSectorDepartmentManage: 'Gestione',
    sampleAnalysisLocation: 'Assegnazione analisi ordinate - sedi', // analysesStatusManagement
    sampleAnalysisLocationView: 'Visualizzazione',
    sampleAnalysisLocationManage: 'Gestione',
    locationCustomer: 'Associazione cliente - sede',
    locationCustomerDepartmentView: 'Visualizzazione',
    locationCustomerDepartmentManage: 'Gestione',
    familyType: 'Template RdP',
    familyTypeView: 'Visualizzazione template RdP',
    familyTypeManage: 'Gestione template RdP',
    stabilityConfig: 'Configurazione stabilità',
    stabilityConfigView: 'Visualizzazione configurazione stabilità',
    stabilityConfigManage: 'Gestione configurazione stabilità',
    stabilityTimePointExport: 'Estrazione T stabilità',
    accrediaSignature: 'Documenti Accredia',
    thermostatSearch: 'Ricerca termostati analisi',
    thermostatSearchManage: 'Gestione',
    symbolSearch: 'Ricerca medium analisi',
    symbolSearchManage: 'Gestione',
    advancedTools: 'Strumenti avanzati',
    advancedRevision: 'Revisione avanzata',
    advancedRevisionView: 'Visualizzazione revisione avanzata',
    monitoringDashboard: 'Monitoraggio Scadenze',
    dashboardMonitoringView: 'Visualizzazione Monitoraggio Scadenze',
    dashboardMonitoringAcceptanceView:
      'Visualizzazione Monitoraggio In attesa di accettazione',
    dashboardMonitoringNoteManage: 'Gestione note Monitoraggio Da completare',
  },
  enums: {
    // Voci ritirate dal vocabolario: restano filtrabili sullo storico, ma
    // l'etichetta dichiara che non si usano più. Vedi config/enumOptions.js
    deprecated: {
      liquidGel: 'Liquido Gel (non più usato)',
    },
    offerType: {
      list: 'Listino',
      quantity: 'Abbonamento',
      brackets: 'Scaglioni',
      null: 'Nessuno',
    },
    laboratories: {
      DEFAULT: 'Default',
      CHIM: 'Chimico',
      // MICRO: 'Microbiologico',
      MICR: 'Microbiologico',
      META: 'Tutti',
    },
    sampleDescriptions: {
      anhydrousFluid: 'Anidro fluido',
      anhydrousPaste: 'Anidro pasta',
      sanitaryTowelsDiapers: 'Assorbenti-Pannolini',
      biphasic: 'Bifasico',
      capsule: 'Capsula',
      tablet: 'Compressa',
      emulsion: 'Emulsione',
      liquidGel: 'Liquido Gel',
      liquid: 'Liquido',
      oil: 'Olio',
      packaging: 'Packaging',
      patch: 'Patch',
      pressedPowder: 'Polvere compattata',
      loosePowder: 'Polvere libera',
      wipes: 'Salviettine',
      validation: 'Validazioni',
      agarPlate: 'Piastra di agar',
      swab: 'Tampone',
      sponge: 'Spugna',
      granulate: 'Granulato',
      water: 'Acqua',
      materialBasedMedicalDevice: 'Dispositivo Medico a base di materiale',
      gel: 'Gel',
      oilyLiquid: 'Liquido oleoso',
      solid: 'Solido',
      propellantSpray: 'Spray con propellente',
      stick: 'Stick',
      fabric: 'Tessuto',
    },
    sectors: {
      other: 'Altro',
      chemical: 'Chimico',
      cosmetic: 'Cosmetico',
      detergents: 'Detergenza',
      medicalDevice: 'Dispositivo medico',
      pharmaceutical: 'Farmaceutico',
      foodSupplement: 'Integratore alimentare per uso umano',
      packaging: 'Materiale di confezionamento',
      biocide: 'Presidio M.C./Biocida',
      nonSterile: 'Prodotti non obbligatoriamente sterili',
      animalWellness: 'Prodotti destinati al benessere degli animali',
      environmental: 'Ambientale',
      OTC: 'OTC',
      microbiologicalMedium: 'Medium microbiologici',
    },
    sampleStatuses: {
      created: 'Creato',
      pending: 'In attesa',
      accepted: 'Accettato',
      inprogress: 'In lavorazione',
      draft: 'Draft',
      concluded: 'Concluso',
      canceled: 'Cancellato',
      rejected: 'Rifiutato',
      suspended: 'Sospeso',
      toBeVerified: 'Da verificare',
      toBeApproved: 'Da approvare',
      completed: 'Completato',
    },
    sampleReportStatuses: {
      draft: 'Bozza',
      inProgress: 'In revisione',
      documentPending: 'Documento in attesa',
      toBeApproved: 'Da firmare',
      approved: 'Firmato',
      revisionato: 'Revisionato',
    },
    sampleActions: {
      accept: 'Accetta',
      reject: 'Rifiuta',
      suspend: 'Sospendi',
      reactivate: 'Riattiva',
      cancel: 'Cancella',
      askApproval: 'Manda in approvazione',
      draft: 'Draft',
      complete: 'Completa',
      removeDraft: 'Termina Draft',
    },
    quarantineReasons: {
      unidentified: 'Non identificato',
      nonCompliant: 'Non conforme',
    },
    stabilityStatus: {
      pending: 'Da configurare',
      processing: 'In elaborazione...',
      configured: 'Configurato',
      error: 'Errore',
    },
    labSampleAnalysisStatuses: {
      created: 'Creato',
      accepted: 'Accettato',
      inprogress: 'In lavorazione',
      completed: 'Completato',
      canceled: 'Cancellato',
      suspended: 'Sospeso',
      pending: 'In attesa',
      rejected: 'Rifiutato',
    },
    comodityCategory: {
      microbiological: 'Microbiologico',
      chemical: 'Chimico',
    },
    reportStatuses: {
      draft: 'Bozza',
      final: 'Definitivo',
      finalRevision: 'Definitivo rev. {revision}',
    },
    symbolTypes: {
      terrain: 'Terreno',
      diluent: 'Diluente',
      Terrain: 'Terreno',
      Diluent: 'Diluente',
    },
    analysisClassTypes: {
      fixed: 'Fissa',
      dynamic: 'Dinamica',
      single: 'Singola',
    },
    dilutions: {
      ' ': '-',
      '1:10': '1:10',
      '1:100': '1:100',
      TQ: 'TQ',
      '1:1:8': '1:1:8',
      '1:1:98': '1:1:98',
    },
    taskTypes: {
      newSentOrder: 'Nuovo ordine inviato',
      newOrdiniWeb: 'Inserimento ordine Onda',
      updateOrderOnda: 'Aggiornamento ordine Onda',
      updateOrder: 'Aggiornamento ordine',
      importOfferPdf: 'Import offerta',
      exportReport: 'Export RdP',
      sampleReport: 'Report Campioni',
      orderReprintInvoce: 'Ristampa fattura',
      unlockedOffer: 'Offerta sbloccata',
      import: 'Import XML',
      updateSample: 'Aggiornamento campione',
      newAddress: 'Nuovo indirizzo',
      canceledSampleReport: 'Report campione cancellato',
      sampleReportToApprove: 'Rapporto di prova da approvare',
    },
    documentType: {
      TestReport: 'Rapporto di Prova',
    },
    signedStatus: {
      signed: 'Firmato',
      unsigned: 'Non firmato',
    },
    taskStatuses: {
      pending: 'In attesa',
      active: 'Attivo',
      failed: 'Fallito',
      completed: 'Completato',
    },
    sampledBy: {
      customer: 'Cliente',
      complife: 'Complife',
    },
    entities: {
      Sample: 'Campione di laboratorio',
      LabSample: 'Campione di laboratorio',
      SampleAnalysisOperationValue: 'Risultati Operazioni',
      LabSampleAnalysisOperationValue: 'Risultati Operazioni',
      UserRoles: 'Ruoli Utente',
      RoleConfig: 'Configurazione Ruoli',
      OperationRegistry: 'Anagrafica Operazioni',
      UserSessionLogin: 'Login utente',
      AnalysisSpecification: 'Specifiche di analisi',
      Thermostat: 'Termostato',
      Quarantine: 'Quarantena',
      LabSampleAnalysisStatus: 'Stato Analisi',
      ReportSampleInfo: 'Info Campione RdP',
      ReportTemperatureLog: 'Temperatura RdP',
      SampleReportRevision: 'Revisione RdP',
    },
    changeTypes: {
      update: 'Aggiornamento',
      removal: 'Rimozione',
      addition: 'Aggiunta',
    },
    sources: {
      advancedRevision: 'Revisione Avanzata',
    },
  },
  auth: {
    login: {
      username: 'Nome utente',
      password: 'Password',
      loginButton: 'Accedi',
    },
    logout: {
      successMessage: 'Logout effettuato con successo',
      label: 'Logout',
    },
  },
  users: {
    title: 'Gestione utenti',
    update: {
      success: 'Utente aggiornato con successo',
      updateUser: 'Aggiorna',
      bulkSuccess: 'Utenti aggiornati con successo',
    },
    create: {
      username: 'Username',
      email: 'Email',
      givenName: 'Nome',
      surname: 'Cognome',
      laboratory: 'Laboratorio',
      role: 'Ruolo',
      abortUpdate: 'Annulla',
      roleExists: 'Ruolo già assegnato',
      location: 'Sede',
    },
  },
  roles: {
    title: 'Gestione ruoli',
    create: {
      createRole: 'Crea ruolo',
      abortCreate: 'Annulla',
      name: 'Nome',
      permissions: 'Permessi',
      success: 'Ruolo creato con successo',
    },
    update: {
      success: 'Ruolo aggiornato con successo',
      updateRole: 'Aggiorna',
    },
  },
  analysisDetail: {
    title: 'Dettaglio analisi',
    analysisNumber: 'N° Analisi',
    code: 'Codice',
    description: 'Descrizione',
    method: 'Metodo',
    methodDescription: 'Descrizione metodo',
    instrument: 'Strumento',
    family: 'Famiglia',
    measure: 'Unità di misura',
    laboratory: 'Laboratorio',
    classType: 'Tipo classe',
    expirationDate: 'Data fine validità',
    accreditedTest: 'Test accreditato',
    aifaTest: 'Test AIFA',
  },
  operations: {
    title: 'Anagrafica Operazioni',
    subtitle: 'Cerca analisi per descrizione, codice o N° articolo',
    table: {
      tableTitle: 'Operazioni predefinite',
      specificationsTableTitle: 'Specifiche addizionali operazioni',
    },
    search: {
      description: 'Descrizione',
      code: 'Codice',
      analysisNumber: 'N° articolo',
      customer: 'Cliente',
      productCode: 'Codice prodotto',
    },
    create: {
      createOperation: 'Crea operazione predefinita',
      abortAction: 'Annulla',
      success: 'Operazione creata con successo',
      sequence: 'Sequenza',
      operation: 'Operazione',
      containerType: 'Contenitore',
      symbol: 'Medium',
      symbolType: 'Tipo medium',
      containerCount: 'Numeri contenitore',
      expectedValue: 'Valore atteso',
      LD: 'LD',
      LQ: 'LQ',
      U: 'U',
      infLimit: 'Limite inferiore',
      supLimit: 'Limite superiore',
      printOnWorksheet: 'Stampa su programma di lavoro',
      printOnLabels: 'Stampa su etichette',
      mainResult: 'Risultato Principale',
      measure: 'Unità di misura',
      included: 'Compreso',
      equal: 'Uguale',
      recoveryFactor: 'Fattore di recupero',
      specificationValue: 'Valore di specifica',
    },
    update: {
      updateOperation: 'Aggiorna operazione',
      success: 'Operazione aggiornata con successo',
    },
    delete: {
      confirm: "Vuoi eliminare l'operazione?",
      success: 'Operazione eliminata con successo',
    },
    copyTo: {
      copyOperation: 'Copia in',
      abortAction: 'Annulla',
      confirmAction: 'Copia',
      success: 'Operazioni copiate con successo',
      duplicateSequenceMessage:
        "Sono presenti operazioni con lo stesso numero di sequenza, l'azione di copia sovrascriverà le operazioni dell'analisi selezionata. Si desidera procedere?",
    },
    analysesWithoutOperations: {
      button: {
        label: 'Mostra Analisi Senza Operazioni',
      },
      dialog: {
        title: 'Analisi Senza Operazioni',
        button: {
          close: {
            label: 'Chiudi',
          },
        },
        table: {
          header: {
            code: 'Codice',
            description: 'Descrizione',
            category: 'Categoria',
          },
        },
      },
    },
    reportConfig: {
      showTemperature: 'Mostra temperatura',
      showSymbol: 'Mostra terreno/diluente',
      showDilution: 'Mostra diluizione',
      defaultDilution: 'Diluizione di default',
    },
  },
  specifications: {
    title: 'Formato limite di analisi',
    limitFormats: {
      absent: 'Assente',
      freeText: 'Testuale singolo',
      selection: 'Selezione',
      range: 'Intervallo',
    },
    addSelection: 'Aggiungi',
    decimalValues: 'Cifre decimali valore',
    noOperator: 'Nessuno',
    lowerOperator: 'Operatore inferiore',
    higherOperator: 'Operatore superiore',
    measure: 'Unità di misura',
    specificationTypes: {
      title: 'Tipo specifica',
      standard: 'Standard',
      custom: 'Custom',
      standardDisabledTooltip:
        'Esiste già una specifica standard per questa operazione',
    },
    create: {
      success: 'Specifica creata con successo',
      createSpecification: 'Aggiungi specifica',
      abortAction: 'Annulla',
      customer: 'Cliente Id / Nome',
      customerProductCode: 'Codice prodotto cliente',
      value: 'Valore',
    },
    update: {
      success: 'Specifica aggiornata con successo',
      updateSpecification: 'Aggiorna specifica',
    },
    delete: {
      confirm: 'Vuoi eliminare la specifica?',
      success: 'Specifica eliminata con successo',
    },
  },
  offers: {
    title: 'Riepilogo Offerte',
    subtitle: 'Cerca offerte per cliente o codice cliente',
  },
  locationsManagement: {
    title: 'Anagrafica sedi',
    createLocation: 'Aggiungi sede',
    create: {
      createLocation: 'Crea sede',
      editLocation: 'Modifica sede',
      name: 'Nome',
      description: 'Descrizione',
      code: 'Codice',
      enabled: 'Attivo',
      aifaEnabled: 'Test AIFA',
      save: 'Salva',
      abort: 'Annulla',
      success: 'Operazione completata con successo',
      materialLabelPrinter: 'Stampante per etichette materiali',
      sampleLabelPrinter: 'Stampante per etichette campioni',
      emails: 'Email segreteria scientifica',
      emailPlaceholder: 'Indirizzo email',
      addEmail: 'Aggiungi email',
    },
  },
  receivedSamples: {
    title: 'Ricevimento campioni',
    accept: {
      title: 'Accetta campioni',
      confirmSingle: 'Confermi di accettare il campione?',
      confirmMultiple:
        'Confermi di accettare il raggruppamento e i suoi campioni?',
      confirm: 'Conferma',
      abort: 'Annulla',
      success: 'Operazione completata con successo',
      needsReprint:
        'Il campione è stato già stampato precedentemente, sarà necessario ristampare le etichette una volta accettato. | Alcuni campioni sono già stati stampati precedentemente, sarà necessario ristampare le etichette una volta accettati.',
      warning:
        'Per lo stesso laboratorio esiste un campione non ancora accettato che ha analisi per altre sedi.',
    },
    refuse: {
      title: 'Rifiuta campioni',
      confirmSingle: 'Confermi di rifiutare il campione?',
      confirmMultiple:
        'Confermi di rifiutare il raggruppamento e i suoi campioni?',
      confirm: 'Conferma',
      abort: 'Annulla',
      comment: 'Commento',
      success: 'Operazione completata con successo',
      rejectReason: 'Inserire una motivazione per il rifiuto',
    },
  },
  workPlanning: {
    title: 'Etichette/Programma di lavoro',
    search: {
      customerName: 'Cliente',
      code: 'Codice',
    },
    dateFrom: 'Data accettazione da',
    dateTo: 'Data accettazione a',
    analysisType: 'Tipo analisi',
    analysisId: 'Codice Analisi',
    groupingId: 'Numero raggruppamento campione',
    sampleCode: 'Codice campione',
    sampleCodeFrom: 'Codice campione da',
    sampleCodeTo: 'Codice campione a',
    previewOnly: 'Visualizzazione anteprima',
    generatePdf: 'Download file PDF',
    printPdf: 'Stampa file',
    printAttachment: 'Stampa allegato',
    samplesLabels: 'Etichette campioni',
    labLabels: 'Etichette laboratorio',
    printType: 'Tipologia',
    printAction: 'Azione di stampa',
    print: 'Stampa',
    workProgram: 'Programma di lavoro',
    orderId: 'Id Ordine',
    generatingProgress: 'Generazione programma di lavoro… {progress}%',
    downloading: 'Download del programma di lavoro in corso…',
    generationFailed: 'Generazione del programma di lavoro non riuscita',
    stampafrazionata: 'Stampa frazionata',
    bulkPrintWarning:
      'Attenzione: la stampa frazionata può richiedere diversi minuti. Non chiudere la pagina durante il processo.',
    materialsPdfBulkPending: 'Stampa frazionata in corso, attendere...',
    materialsPdfBulkSuccess:
      'Stampa completata: {samplesProcessed} campioni in {batches} batch',
    materialsPdfBulkWarning:
      'Stampa completata con {failedBatches} batch falliti: {samplesProcessed} campioni in {batches} batch',
  },
  quarantine: {
    title: 'Quarantena',
    sourceLabel: {
      receivedSamples: 'Ricevimento campioni',
      quarantine: 'Quarantena',
    },
    send: {
      status: 'Stato',
      comment: 'Commento',
      abort: 'Annulla',
      confirm: 'Conferma',
      success: 'Campione spostato in quarantena',
    },
    create: {
      success: 'Campione creato con successo',
      createSample: 'Crea campione',
      import: 'Caricamento massivo XLSX',
      downloadExample: 'Download XLSX',
      labSampleCode: 'Codice prodotto',
      productName: 'Nome prodotto',
      customerProductName: 'Codice Campione cliente',
      lot: 'Lotto',
      date: 'Data lotto',
      sector: 'Settore',
      packagesNumber: 'N° Campioni',
      notes: 'Note del cliente',
      finalCustomer: 'Cliente Finale',
      sampleDescription: 'Descrizione Campione',
      comments: 'Commenti',
      costCenter: 'Centro di costo cliente',
      quarantineReason: 'Ragione quarantena',
      abortCreate: 'Annulla',
      actions: 'Azioni',
    },
    update: {
      updateSample: 'Aggiorna campione',
      success: 'Campione aggiornato con successo',
    },
    accept: {
      description: 'Accettare il campione?',
      title: 'Accetta campione',
      confirm: 'Conferma',
      abort: 'Annulla',
      sampleCode: 'Codice campione',
      sampleName: 'Nome Campione',
      sampleCodeRequired: 'Codice campione richiesto',
    },
    refuse: {
      description: 'Rifiutare il campione?',
      title: 'Rifiuta campione',
      rejectReason: 'Motivazione del rifiuto',
    },
  },
  samplegrouping: {
    title: 'Informazioni raggruppamenti',
    close: 'Chiudi',
  },
  samples: {
    sectors: {
      foodSupplement: 'Integratore alimentare per uso umano',
      other: 'Altro',
      chemical: 'Chimico',
      cosmetic: 'Cosmetico',
      detergents: 'Detergenza',
      medicalDevice: 'Dispositivo medico',
      packaging: 'Materiale di confezionamento',
      biocide: 'Presidio M.C./Biocida',
      pharmaceutical: 'Farmaceutico',
      nonSterile: 'Prodotti non obbligatoriamente sterili',
      animalWellness: 'Prodotti destinati al benessere degli animali',
      environmental: 'Ambientale',
      OTC: 'OTC',
      microbiologicalMedium: 'Medium microbiologici',
    },
    sampleDescriptions: {
      anhydrousFluid: 'Anidro fluido',
      anhydrousPaste: 'Anidro pasta',
      sanitaryTowelsDiapers: 'Assorbenti-Pannolini',
      biphasic: 'Bifasico',
      capsule: 'Capsula',
      tablet: 'Compressa',
      emulsion: 'Emulsione',
      liquidGel: 'Liquido Gel',
      liquid: 'Liquido',
      oil: 'Olio',
      packaging: 'Packaging',
      patch: 'Patch',
      pressedPowder: 'Polvere compattata',
      loosePowder: 'Polvere libera',
      wipes: 'Salviettine',
      validation: 'Validazioni',
      agarPlate: 'Piastra di agar',
      swab: 'Tampone',
      sponge: 'Spugna',
      granulate: 'Granulato',
      water: 'Acqua',
      materialBasedMedicalDevice: 'Dispositivo Medico a base di materiale',
      gel: 'Gel',
      oilyLiquid: 'Liquido oleoso',
      solid: 'Solido',
      propellantSpray: 'Spray con propellente',
      stick: 'Stick',
      fabric: 'Tessuto',
    },
  },
  analysesData: {
    title: 'Inserimento dati analisi',
    combinedTab: 'Dettagli dati analisi combinati',
    sampleComments: 'Note aggiuntive',
    expectedValues: {
      title: 'Inserisci valori attesi',
      startDate: 'Data inizio analisi',
      endDate: 'Data fine analisi',
      groupingId: 'Raggruppamento campioni',
      insertExpectedValuesBulk:
        'Inserisci valori attesi per i campioni selezionati',
    },
    askApprovalSample: {
      title: 'Stato campione',
      message: 'Inviare il campione in approvazione?',
      success: 'Stato aggiornato',
    },
    bulkActions: {
      enableRawData: 'Abilita anticipo risultati',
      disableRawData: 'Disabilita anticipo risultati',
      insertExpectedValues: 'Inserisci valori attesi',
      bulkAskApproval: "Manda in approvazione tutto l'elenco",
      viewCombined: 'Visualizza dettagli combinati',
      insertTemperature: 'Inserisci temperatura di incubazione',
      insertSymLot: 'Inserisci lotto diluente e terreno',
      importFromFile: 'Import da file',
    },
    importValues: {
      title: 'Import valori analisi da file',
      steps: {
        upload: 'Caricamento file',
        columns: 'Associazioni colonne',
        summary: 'Riepilogo',
        write: 'Scrittura',
      },
      unmappedColumnsNoPermission:
        "Una colonna del file non è associata a un'analisi né ignorata: chiedi a un responsabile di configurarla. | {count} colonne del file non sono associate a un'analisi né ignorate: chiedi a un responsabile di configurarle.",
      upload: {
        dropFile: 'Trascina qui il file .csv',
        clickToSelect: 'oppure fai clic per selezionarlo',
        fileTip:
          'Solo file .csv esportati da Qtegra, fino a 1 MB e 1.000 righe',
        notCsv:
          "Il file non è in formato .csv: caricare l'export di Qtegra in formato .csv",
        dateStart: 'Inizio analisi',
        dateEnd: 'Fine analisi',
        datePlaceholder: 'gg-mm-aaaa',
        prepare: 'Analizza file',
        unresolvedLabels:
          '1 label da correggere in {file} | {count} label da correggere in {file}',
        copyFileError: 'Copia errore',
      },
      columns: {
        search: {
          label: 'Cerca associazioni',
          field: 'Cerca per',
          placeholder: 'Cerca',
          fields: {
            column: 'Colonna',
            analysis: 'Analisi',
          },
        },
        sourceColumn: 'Colonna del file',
        unmapped: 'Da associare',
        ignored: 'Ignorata',
        pending: 'Da salvare',
        ignoredCells: 'Le celle di questa colonna non vengono importate',
        empty: 'Nessuna associazione',
        analysis: {
          label: 'Analisi',
          placeholder: 'Cerca per codice o descrizione',
        },
        ldThreshold: {
          label: 'Soglia LD',
          placeholder: 'es. 0,05',
        },
        decimals: {
          label: 'Decimali',
        },
        measure: {
          label: 'Unità di misura',
          placeholder: 'Cerca unità',
        },
        actions: {
          label: 'Azioni',
          duplicate: 'Duplica',
          ignore: 'Ignora',
          map: 'Associa',
          deactivate: 'Disattiva',
          remove: 'Rimuovi',
          undo: 'Annulla',
          confirmDeactivate:
            "L'associazione non sarà più usata da nessun import.",
          confirmDeactivateIgnored:
            'La colonna non sarà più ignorata e andrà associata.',
          confirmIgnore:
            'Tutte le associazioni attive della colonna saranno disattivate.',
        },
        errors: {
          required: 'Obbligatorio',
          ldThreshold: 'Un numero maggiore di zero',
          decimals: 'Un numero intero da 0 a {max}',
        },
        pendingWrites: '1 modifica da salvare | {count} modifiche da salvare',
        leftUnmapped:
          '1 colonna del file resta da associare: i suoi valori non saranno importati | {count} colonne del file restano da associare: i loro valori non saranno importati',
        invalidRows: '1 riga da completare | {count} righe da completare',
        writeFailed: '1 modifica non salvata | {count} modifiche non salvate',
        proceed: 'Continua',
      },
      confirmBack:
        'Le modifiche non salvate andranno perse. Tornare al caricamento del file?',
      summary: {
        counts: {
          toWrite:
            'Nessun valore da scrivere | 1 valore da scrivere | {count} valori da scrivere',
          overwrites: '1 sovrascrittura | {count} sovrascritture',
          errors: '1 riga in errore | {count} righe in errore',
          nonCompliant: '1 valore non conforme | {count} valori non conformi',
        },
        columns: {
          sample: 'Campione',
          sourceRow: 'Riga {row} · {column}',
          analysis: 'Analisi',
          value: 'Valore',
          ld: 'LD',
          measure: 'Unità',
          proposed: 'Proposto',
          current: 'Attuale',
          status: 'Stato',
          include: 'Includi',
        },
        inputs: {
          value: 'Valore misurato',
          ld: 'Soglia LD',
          include: 'Includi la riga',
        },
        proposedLd: 'LD {ld}',
        overwrite: 'Sarà sovrascritto',
        nonCompliant: 'Valore non conforme',
        chooseOne: 'Scegline una',
        notImported: 'Non importare',
        states: {
          ok: 'Valida',
          excluded: 'Esclusa',
        },
        errors: {
          analysisNotOnSample: {
            title: 'Analisi non presente',
            fix: 'Nessuna analisi del campione è associata a questa colonna.',
          },
          targetOperationNotFound: {
            title: 'Operazione non trovata',
            fix: "Il campione non ha un'unica operazione di risultato principale per questa analisi.",
          },
          statusNotEditable: {
            title: 'Non modificabile',
            fix: "Lo stato del campione o dell'analisi non consente di inserire il valore.",
          },
          analysisStartBeforeAcceptance: {
            title: "Inizio prima dell'accettazione",
            fix: 'La data inizio analisi è anteriore all\'accettazione del campione: correggerla con "Precedente".',
          },
          analysisAmbiguous: {
            title: 'Analisi ambigua',
            fix: 'Più analisi del campione sono associate a questa colonna: scegline una.',
          },
          duplicateTarget: {
            title: 'In conflitto',
            fix: "Un'altra colonna scrive lo stesso valore di questa analisi: includerne una sola.",
          },
          valueNotNumeric: {
            title: 'Valore non numerico',
            fix: 'Inserire un numero, con il punto o la virgola come separatore decimale.',
          },
          ldThreshold: {
            title: 'Soglia LD non valida',
            fix: 'Inserire un numero maggiore di zero.',
          },
          unknown: {
            title: 'Errore',
          },
        },
        empty: 'Nessun valore da importare',
        unmappedColumns: {
          title:
            '1 colonna del file non è associata: i suoi valori non sono importati | {count} colonne del file non sono associate: i loro valori non sono importati',
          fix: 'Per importarli, associala con "Modifica mappatura colonne". | Per importarli, associale con "Modifica mappatura colonne".',
          fixNoPermission:
            'Per importarli, chiedi a un responsabile di associarla. | Per importarli, chiedi a un responsabile di associarle.',
        },
        blocked:
          '1 riga inclusa da correggere o escludere | {count} righe incluse da correggere o escludere',
        editColumns: 'Modifica mappatura colonne',
        confirmEditColumns:
          'Le modifiche alle righe andranno perse: il riepilogo sarà ricalcolato.',
        proceed: 'Procedi',
      },
      write: {
        written:
          'Nessun valore scritto | 1 valore scritto | {count} valori scritti',
        overwritten: 'di cui 1 sovrascritto | di cui {count} sovrascritti',
        failed: '1 riga non scritta | {count} righe non scritte',
        columns: {
          error: 'Errore',
        },
        retry: 'Riprova righe fallite',
        progress: {
          title: 'Scrittura del valore {current} di {total}',
          remaining: 'Tempo stimato: {time}',
        },
      },
      issueLine: '{title} ({count}): {fix}',
      unresolvedLabels: {
        title:
          'Il file contiene 1 label da correggere | Il file contiene {count} label da correggere',
        copy: 'Copia errori',
        columns: {
          sourceRow: 'Riga',
          label: 'Label',
          issue: 'Problema',
          fix: 'Come correggere',
        },
      },
      labelIssues: {
        notFound: {
          title: 'Campione non trovato',
          fix: 'Nessun campione con questo codice nei laboratori e nelle sedi abilitate.',
        },
        duplicate: {
          title: 'Label duplicata',
          fix: 'La stessa label compare su più righe: lasciarne una sola.',
        },
        unknown: {
          title: 'Problema non riconosciuto',
          fix: 'Verificare la label nel file e ricaricarlo.',
        },
      },
      malformedCodes: {
        title:
          '1 codice campione non valido: la riga non sarà importata | {count} codici campione non validi: le righe non saranno importate',
        copy: 'Copia righe',
        missingLocationLetter: {
          title: 'Lettera di sede mancante',
          fix: 'Aggiungere la lettera di sede in fondo al codice (es. 01561.26C21370G) e ricaricare il file.',
        },
        unexpectedFormat: {
          title: 'Formato del codice non valido',
          fix: 'Il codice deve avere la forma 01561.26C21370G, senza spazi né suffissi.',
        },
        unknown: {
          title: 'Codice non riconosciuto',
          fix: 'Verificare il codice nel file e ricaricarlo.',
        },
      },
      ignoredRows: {
        title: '1 riga ignorata | {count} righe ignorate',
        reasonCount: '{reason}: {count}',
        malformedReason: '{reason}: {issue}',
        columns: {
          sourceRow: 'Riga',
          label: 'Label',
          reason: 'Causa',
        },
        reasons: {
          malformedSampleCode: 'Codice campione non valido',
          emptyLabel: 'Label vuota',
          notSampleCode: 'Non è un codice campione',
          unknown: 'Causa non riconosciuta',
        },
      },
    },
    symbolLotBulkEdit: {
      symbol: 'Medium',
      lot: 'Lotto',
      details: 'Dettagli',
      sample: 'Codice campione',
      analysis: 'Analisi',
      analysisCode: 'Codice Analisi',
      operation: 'Operazione',
    },
    sampleSymLotBulk: {
      analysis: 'Analisi',
      analysisCode: 'Codice analisi',
      operation: 'Operazione',
      details: 'Dettagli',
      sample: 'Codice campione',
      symbol: 'Medium',
      lot: 'Lotto',
    },
    valuesTemperatureBulk: {
      // FIXME: Specificare meglio il tipo di errore
      invalidTrails: 'Temperature non valide per le analisi selezionate',
      title: 'Inserimento Temperature',
      step1: 'Termostato e Temperatura',
      step2: 'Raggruppamenti',
      step3: 'Analisi',
      step4: 'Selezione campioni',
      step5: 'Data Apertura e Chiusura',
      step6: 'Riepilogo',
      thermostatCode: 'Codice termostato',
      thermostatName: 'Nome termostato',
      thermostatTemp: 'Temperatura impostata',
      notEnabledErr: 'Termostato non attivo',
      noTemperatureErr:
        'Il termostato inserito non ha una temperatura impostata',
      notFound: 'Termostato non trovato',
      noSamples:
        'Non sono presenti campioni che soddisfano i criteri di inserimento',
      noAnalysis: 'Analisi non trovata',
      noValuesInAnalysis:
        "Uno o più campioni legati all'analisi selezionata non hanno valori inseriti",
      groupingId: 'Codice raggruppamento',
      analysisCode: 'Codice analisi',
      qrScanExplanation:
        'Scansiona un codice QR oppure inseriscilo manualmente e premi INVIO',
      summaryText:
        'Verrà creata o modificata una traccia temperatura di {thermostatTemperature} del termostato {thermostatCode} per le analisi {analysisCodes} e i seguenti campioni:',
      createTrace: 'Crea traccia',
      closeTrace: 'Chiudi traccia',
      startDateTime: 'Data e ora di apertura',
      endDateTime: 'Data e ora di chiusura',
      invalidSamples: 'È necessario selezionare uno o più campioni',
      invalidSamplesSelection:
        'È necessario selezionare campioni con solo tracce da aprire o solo da chiudere',
      endBeforeTrailStart:
        "La data di chiusura non può essere precedente all'apertura della traccia ({startedAt})",
      thermostatWarning: {
        title: 'Avviso di termostato diverso in chiusura traccia',
        message:
          'Attenzione: stai chiudendo la traccia su un termostato diverso da quello utilizzato in apertura. Vuoi procedere?',
        selectedThermostat: 'Termostato selezionato',
        labSampleCode: 'Codice campione',
        openingThermostat: 'Termostato di apertura',
        proceed: 'Procedi',
      },
    },
    valuesSymLotBulk: {
      title: 'Associazione lotto diluente e terreno',
      step1: 'Raggruppamenti',
      step2: 'Analisi',
      step3: 'Operazioni',
      step4: 'Lotto diluente/terreno',
      noSamples:
        'Non sono presenti campioni che soddisfano i criteri di inserimento',
      noAnalysis: 'Analisi non trovata',
      groupingId: 'Codice raggruppamento',
      analysisCode: 'Codice analisi',
      analysisDescription: 'Descrizione analisi',
      qrScanExplanation:
        'Scansiona un codice QR oppure inseriscilo manualmente e premi INVIO',
      noOperation: 'Non ci sono operazioni con lotti da inserire',
      noSample: 'Non ci sono campioni con lotti da inserire',
    },
    changeDilution: {
      title: 'Cambia diluizione per {sample}',
      label: 'Diluizione',
      update: 'Aggiorna',
    },
    associateLocation: {
      title: 'Associazione sede',
      location: 'Sede',
    },
    changeSamplingInformation: {
      title: 'Modifica informazioni campionamento',
      update: 'Aggiorna',
      samplingDate: 'Data di campionamento',
      samplingPlace: 'Luogo di campionamento',
      samplingPlan: 'Piano di campionamento',
      samplingMethod: 'Metodo di campionamento',
      samplingBy: 'Campionamento eseguito da',
      samplingAccredited: {
        label: 'Campionamento accreditato',
        active: 'Sì',
        inactive: 'No',
      },
    },
  },
  sampleDetails: {
    title: 'Dettagli campione',
    tabLabel: 'Dettagli',
    cancelAnalysisError:
      "C'è stato un errore durante la richiesta, riprova più tardi",
    cancelAnalysisWithParent:
      "Tutti i figli dell'analisi '{code}' ancora in corso nel campione saranno annullati.",
    measuredValues: {
      title: 'Inserisci valori rilevati',
      value: 'Valore',
      LD: 'LD',
      LQ: 'LQ',
      U: 'U',
      symbol: 'Medium',
      symbolType: 'Tipo medium',
      symbolLot: 'Lotto simbolo',
      infLimit: 'Limite inferiore',
      supLimit: 'Limite superiore',
      analysisStart: 'Data inizio analisi',
      analysisEnd: 'Data fine analisi',
      measure: 'Unità di misura',
      notes: 'Note',
      thermostat: 'Termostato',
      temperature: 'Temperatura',
      specification: 'Specifica',
      valueWarningMessage: 'Valore non conforme',
      recoveryFactor: 'Fattore di recupero',
    },
    temperatureTrail: {
      title: 'Traccia temperatura',
      thermostat: 'Termostato',
      startedAt: 'Data inizio',
      endedAt: 'Data fine',
      temperature: 'Temperatura',
    },
    locationClassWarning:
      "L'analisi selezionata appartiene a una classe. Premi 'Conferma' per spostare l'intera classe oppure 'Indietro' per interrompere l'operazione.",
  },
  analysesStatusManagement: {
    title: 'Gestione status analisi',
    combinedTab: 'Dettagli stato analisi combinati',
    groupingStatus: {
      title: 'Cambia status a un campione | Cambia status a {count} campioni',
      titleSingle: '{action} un campione | {action} {count} campioni',
      bulkAlert: 'La seguente azione verrà applicata su {sampleCount} campioni',
      status: 'Stato',
      success: 'Stato aggiornato',
      analysisNotes: 'Note analisi',
      actionReason: 'Motivo',
      results: 'Risultati:',
      completedNoErrors: 'Azioni completate senza errori:',
      errors: 'Errori:',
    },
    editLabNotes: {
      title: 'Modifica note campione',
      notes: 'Note campione',
    },
    draft: {
      title: 'Draft campione',
      message: 'Abilitare lo stato "Draft" del campione?',
      success: 'Stato aggiornato',
    },
    removeDraft: {
      title: 'Draft campione',
      message: 'Terminare lo stato "Draft" del campione?',
      success: 'Stato aggiornato',
    },
    removeUploadedReport: {
      title: 'Rimuovi relazione',
      message:
        'Rimuovere la relazione caricata? Potrai caricarne una nuova al suo posto.',
      success: 'Relazione rimossa',
      alreadySigned:
        'La relazione è già stata firmata: per correggerla crea una revisione',
      notRemovable:
        'Solo una relazione Challenge caricata e in attesa di firma può essere rimossa',
    },
    printSample: {
      title: 'Stampa campione',
      message: 'Stampare il campione?',
    },
    revision: {
      title: 'Revisione',
      step1: 'Revisione',
      step2: 'Campione',
      step3: 'Analisi',
      whodunnit: 'Specifica la richiesta di revisione',
      customerError: 'Errore del cliente - con fatturazione separata',
      ownError: 'Errore di Complife - senza fatturazione separata',
      errorNotes: 'Motivazione',
      labSampleCode: 'Codice prodotto',
      productName: 'Nome prodotto',
      sampleCode: 'Codice campione',
      lot: 'Lotto',
      lotDate: 'Data lotto',
      sector: 'Settore',
      packagesNumber: 'N. Campioni',
      notes: 'Note del cliente',
      finalCustomer: 'Cliente finale',
      sampleDescription: 'Descrizione campione',
      comments: 'Istruzioni testuali',
      costCenter: 'Centro di costo cliente',
      infLimit: 'Val. rif. inf.',
      supLimit: 'Val. rif. sup.',
      measure: 'Unità di misura',
      value: 'Valore',
      LD: 'LD',
      U: 'U',
      LQ: 'LQ',
      success: 'Revisione creata con successo',
      invoice: 'Richiedere fatturazione per ristampa?',
      invoiceRequired: 'Fatturazione per ristampa',
    },
    download: 'Download',
    edit: {
      title: 'Modifica campione {labSampleCode}',
      success: 'Campione modificato con successo',
      updateSample: 'Modifica campione',
      labSampleCode: 'Codice prodotto',
      productCode: 'Codice prodotto',
      productName: 'Nome prodotto',
      customerProductName: 'Codice Campione cliente',
      comments: 'Commenti',
      analysisNotes: 'Note Analisi',
      abortCreate: 'Annulla',
      actions: 'Azioni',
      lot: 'Lotto',
      date: 'Data lotto',
      clientNotes: 'Note cliente',
      finalCustomer: 'Cliente finale',
      customerHeaderData:
        "Vuoi inserire nell'intestazione del rapporto di prova i dati del cliente finale?",
      customerHeaderDataYes: 'Sì',
      customerHeaderDataNo: 'No',
      customerAddress: 'Indirizzo cliente',
      costCenter: 'Centro di costo del cliente',
      packagesNumber: 'N° Campioni',
      sampleDescription: 'Descrizione Campione',
      sector: 'Settore',
      address: {
        addNew: 'Aggiungi nuovo',
        name: 'Ragione sociale',
        address: 'Indirizzo',
        city: 'Città',
        zip: 'CAP',
        province: 'Provincia',
        countryCode: 'Codice paese',
        phoneNumber: 'Numero di telefono',
        sharedAddressNotice:
          "Codice paese e Provincia verranno aggiornati sull'indirizzo del cliente: la modifica vale per tutti i campioni che lo utilizzano.",
      },
    },
    bulkActions: {
      changeSamplesStatus: 'Cambia stato campioni',
      enableRawData: 'Abilita anticipo risultati',
      disableRawData: 'Disabilita anticipo risultati',
    },
    testReports: {
      title: 'Scarica rapporti di prova',
    },
  },
  analysesSearch: {
    title: 'Ricerca',
    search: {
      customerName: 'Cliente',
      code: 'Codice',
    },
    customerName: 'Cliente',
    code: 'Codice',
    customerId: 'ID Cliente',
    sampleReceivedFrom: 'Data ricevimento da',
    sampleReceivedTo: 'Data ricevimento a',
    sampleCompletedFrom: 'Data chiusura campione da',
    sampleCompletedTo: 'Data chiusura campione a',
    lab: 'Laboratorio',
    commodityCode: 'Laboratorio',
    sector: 'Settore',
    sampleDescription: 'Descrizione campione',
    analysisCode: 'Codice analisi',
    method: 'Metodo',
    symbol: 'Medium (diluente / terreno)',
    symbolArray: 'Simboli (diluente / terreno)',
    symbollot: 'Lotto simbolo',
    symbolLotArray: 'Lotti Simboli (diluente / terreno)',
    lot: 'Codice lotto',
    labSampleCode: 'Codice prodotto',
    sampleName: 'Nome campione',
    productName: 'Nome campione',
    status: 'Stato',
    sampleStatus: 'Stato',
    result: 'Risultato',
    value: 'Risultato',
    printType: 'Tipologia di stampa',
    brief: 'Sintetica',
    detailed: 'Dettagliata',
    print: 'Stampa',
    excelExport: 'Esporta Excel',
    searchSamples: 'Cerca',
    searchResult:
      'Nessuna analisi con valori trovata | {count} analisi con valori trovata | {count} analisi con valori trovate',
    limitReached:
      'Limite di stampa di {count} risultati superato, modificare la specificità dei filtri',
    accredited: {
      label: 'Analisi accreditata',
      active: 'Sì',
      inactive: 'No',
    },
  },
  printAnalyses: {
    title: 'Stampa elenco analisi',
    customerNameFrom: 'Cliente da',
    customerCodeFrom: 'Codice cliente da',
    customerNameTo: 'Cliente a',
    customerCodeTo: 'Codice cliente a',
    acceptedFrom: 'Ricevimento da',
    acceptedTo: 'Ricevimento a',
    analysisEndFrom: 'Chiusura analisi da',
    analysisEndTo: 'Chiusura analisi a',
    commodityCode: 'Tipologia analisi',
    sampleCodeFrom: 'Codice campione da',
    sampleCodeTo: 'Codice campione a',
    analysisCode: 'Codice analisi',
    analysisDescription: 'Descrizione analisi',
    categoryDescription: 'Descrizione categoria',
    methodDescription: 'Descrizione metodo',
    analysisStatus: "Stato dell'analisi",
    orderId: 'ID ordine',
    analysisDueFrom: 'Presunta consegna da',
    analysisDueTo: 'Presunta consegna a',
    instrument: 'Strumento',
    printType: 'Tipo di stampa',
    briefPrint: 'Sintetica',
    detailedPrint: 'Dettagliata',
    expandClasses: 'Esplodi classi',
    expandClassesLabel: 'Classi di analisi',
    excludePrepaidOffers:
      'Escludi analisi con abbonamento o pagamento anticipato',
    excludePrepaidOffersLabel: 'Pagamento',
    onlyPrepaidOffers:
      'Mostra solo analisi con abbonamenti o pagamenti anticipati',
    allPrepaidOffers: 'Mostra tutte le analisi',
    printMode: 'Modalità di stampa',
    pdfPrint: 'Pdf',
    excelPrint: 'Excel',
    print: 'Stampa',
    finalCustomerName: 'Cliente finale',
    groupingId: 'Raggruppamento',
    accreditedPharma: 'Accreditato/Farma',
    noAccredited: 'Non accreditato',
    accredited: 'Accreditato',
    pharma: 'Farma',
    location: 'Sede',
    signedAtFrom: 'Data firma da',
    signedAtTo: 'Data firma a',
    sampleStatus: 'Stato dei campioni',
  },
  signatureConfig: {
    title: 'Firma rapporto di prova',
    image: 'Immagine firma',
    notJpg: "L'immagine deve essere in formato .jpg",
    sizeExceeded: "L'immagine non deve superare 1mb di dimensione",
    upload: 'Upload',
    uploadSuccess: 'Upload completato con successo',
    saveSuccess: 'Configurazione salvata con successo',
    name: 'Nome firma',
    save: 'Salva',
    activationDate: 'Data di attivazione',
    expirationDate: 'Data di scadenza',
    status: 'Stato',
    user: 'Utente',
    password: 'Password',
    displayTitle: 'Titolo da mostrare sul rapporto di prova',
  },
  changeLog: {
    title: 'Lista Modifiche',
    startDate: 'Data inizio',
    endDate: 'Data fine',
    download: 'Scarica file',
    detail: {
      added: 'Aggiunte',
      updated: 'Modifiche',
      removed: 'Rimozioni',
      errorMessage: 'Nessun dettaglio disponibile',
      field: 'Campo',
      oldValue: 'Vecchio valore',
      newValue: 'Nuovo valore',
      permissionsRemoved: 'Permessi rimossi',
      permissionsAdded: 'Permessi aggiunti',
      information: 'Informazioni entità',
    },
    permissions: {
      rolesView: 'Ruoli - Visualizzazione',
      rolesManage: 'Ruoli - Gestione',
      usersView: 'Utenti - Visualizzazione',
      usersManage: 'Utenti - Gestione',
      operationsView: 'Anagrafica operazioni - Visualizzazione',
      operationsManage: 'Anagrafica operazioni - Gestione',
      receivedSamplesView: 'Ricevimento campioni - Visualizzazione',
      receivedSamplesDownload: 'Ricevimento campioni - Download',
      receivedSamplesManage: 'Ricevimento campioni - Gestione',
      workPlanningManage: 'Etichette / Programma di lavoro - Gestione',
      quarantineView: 'Quarantena - Visualizzazione',
      quarantineManage: 'Quarantena - Gestione',
      analysesDataView: 'Inserimento dati analisi - Visualizzazione',
      analysesDataManage: 'Inserimento dati analisi - Gestione',
      analysisImportMappingView:
        'Associazioni colonne import da file - Visualizzazione',
      analysisImportMappingManage:
        'Associazioni colonne import da file - Gestione',
      analysesStatusView: 'Status analisi - Visualizzazione',
      analysesStatusManage: 'Status analisi - Gestione',
      analysesWorkPlanningView: 'Programma di lavoro analisi - Visualizzazione',
      analysesWorkPlanningManage: 'Programma di lavoro analisi - Gestione',
      printReportManage: 'Stampa rapporto di prova - Gestione',
      printAnalysesManage: 'Stampa elenco analisi - Gestione',
      searchManage: 'Ricerca - Gestione',
      changelogView: 'Lista modifiche - Visualizzazione',
      thermostatsView: 'Termostati - Visualizzazione',
      thermostatsManage: 'Termostati - Gestione',
      analysisDataTemperatureView: 'Temperatura incubazione - Visualizzazione',
      analysisDataTemperatureManage: 'Temperatura incubazione - Gestione',
      terrainDiluentLotView: 'Lotto terreni e diluenti - Visualizzazione',
      terrainDiluentLotManage: 'Lotto terreni e diluenti - Gestione',
      systemAdministration: 'Amministrazione sistema',
      signatureUser: 'Firma digitale - Firma documenti',
      signatureManage: 'Firma digitale - Gestione',
      locationsView: 'Sedi - Visualizzazione',
      locationsManage: 'Sedi - Gestione',
      analysisLocationView: 'Associazione analisi - sede - Visualizzazione',
      analysisLocationsManage: 'Associazione analisi - sede - Gestione',
      locationSectorDepartmentView:
        'Associazione settore - sede - Visualizzazione',
      locationSectorDepartmentManage: 'Associazione settore - sede - Gestione',
      sampleAnalysisLocationView:
        'Assegnazione analisi ordinate - sedi - Visualizzazione',
      sampleAnalysisLocationManage:
        'Assegnazione analisi ordinate - sedi - Gestione',
      locationCustomerDepartmentView:
        'Associazione cliente - sede - Visualizzazione',
      locationCustomerDepartmentManage:
        'Associazione cliente - sede - Gestione',
      familyTypeView: 'Template RdP - Visualizzazione',
      familyTypeManage: 'Template RdP - Gestione',
      stabilityConfigView: 'Configurazione stabilità - Visualizzazione',
      stabilityConfigManage: 'Configurazione stabilità - Gestione',
      stabilityTimePointExport: 'Estrazione T stabilità',
      accrediaSignature: 'Documenti Accredia',
      thermostatSearchManage: 'Ricerca termostati analisi - Gestione',
      symbolSearchManage: 'Ricerca medium analisi - Gestione',
      advancedRevision: 'Revisione avanzata',
      advancedRevisionView: 'Revisione avanzata - Visualizzazione',
    },
    fields: {
      analysisId: 'Analisi Id',
    },
  },
  thermostats: {
    title: 'Anagrafica termostati',
    create: {
      title: 'Aggiungi termostato',
      createThermostat: 'Aggiungi termostato',
      success: 'Termostato aggiunto con successo',
      name: 'Nome',
      enabled: 'Attivo',
      abortCreate: 'Annulla',
    },
    update: {
      title: 'Aggiorna termostato',
      success: 'Termostato aggiornato con successo',
      updateThermostat: 'Aggiorna termostato',
    },
    log: {
      title: 'Storico temperature',
      startDate: 'Data inizio',
      endDate: 'Data fine',
      configuredTemperature: 'Temperatura',
    },
    temperature: {
      title: 'Modifica temperatura',
      message: 'Inserisci un valore in ˚C',
    },
  },
  tasks: {
    title: 'Attività',
    restart: {
      message: "Confermi il riavvio dell'attività?",
      title: 'Riavviare attività {taskId}?',
      success: 'Attività {taskId} riavviata con successo',
    },
  },
  systemConfig: {
    title: 'Sistema',
    printers: 'Stampanti',
    printerName: 'Nome stampante CUPS',
    'printWidth-mm': 'Larghezza stampa (mm)',
    'printHeight-mm': 'Altezza stampa (mm)',
    'labelWidth-mm': 'Larghezza etichetta (mm)',
    'labelHeight-mm': 'Altezza etichetta (mm)',
    'labelMarginTop-mm': 'Margine alto etichetta (mm)',
    'labelMarginLeft-mm': 'Margine sinistro etichetta (mm)',
    'labelColSpacing-mm': 'Spaziatura etichetta (mm)',
    showCalibrationBorder: 'Mostra margine per calibrazione',
    materialLabels: 'Etichette materiali',
    sampleLabels: 'Etichette campioni',
    save: 'Salva',
    saveSuccess: 'Configurazione salvata con successo',
  },
  recipients: {
    title: 'Gruppi di firma',
    create: {
      createRecipient: 'Crea gruppo di firma',
      editRecipient: 'Modifica gruppo di firma',
      name: 'Nome',
      role: 'Ruolo',
      laboratory: 'Laboratorio',
      documentType: 'Tipo di documento',
      abort: 'Annulla',
      save: 'Salva',
      success: 'Gruppo di firma salvato con successo',
    },
    delete: {
      message: 'Vuoi eliminare il gruppo di firma?',
      title: 'Rimuovi gruppo di firma',
      success: 'Gruppo di firma rimosso',
    },
  },
  signDocuments: {
    title: 'Firma documenti',
    send: 'Invia',
    cancel: 'Annulla',
    verify: 'Verifca',
    sendOtp: 'Per favore inserisci il tuo otp.',
    otpVerified: 'Otp verificato!',
    signMany: 'Firma molteplici',
    signedDocuments: 'Documenti firmati',
    fileName: 'rapporto-di-prova-{date}.pdf',
  },
  signatureProfiles: {
    title: 'Profili di firma',
    credentials: {
      title: 'Aggiorna le credenziali',
      abort: 'Annulla',
      username: 'Username',
      password: 'Password',
      send: 'Invia',
      success: 'Credenziali inviate con successo',
    },
  },
  approvalCustomerChanges: {
    title: 'Approvazione modifiche cliente',
    approve: 'Approva',
    reject: 'Rifiuta',
    viewDiffModal: 'Visualizza modifiche',
    propertyName: 'Nome campo',
    original: 'Originale',
    edited: 'Modifica',
    approveConfirm: {
      title: 'Approva modifica',
      message: 'Approvare la modifica?',
    },
    rejectConfirm: {
      title: 'Rifiuta modifica',
      message: 'Rifiutare la modifica?',
    },
  },
  sectorsAssociation: {
    title: 'Associazione settori',
    createSector: 'Aggiungi settore',
    create: {
      createSector: 'Crea settore',
      editSector: 'Modifica settore',
      sector: 'Settore',
      laboratory: 'Laboratorio',
      location: 'Sede',
      save: 'Salva',
      abort: 'Annulla',
      success: 'Operazione completata con successo',
    },
  },
  defaultLocations: {
    title: 'Associazione analisi',
    subtitle: 'Cerca analisi per descrizione o codice',
    search: {
      description: 'Descrizione',
      code: 'Codice',
    },
    create: {
      createLocation: 'Associa sede',
      legalConstraint: 'Vincoli normativi',
      motivation: 'Descrizione',
      location: 'Sede',
      abortAction: 'Annulla',
      analysisCode: 'Codice analisi',
      analysisDescriprion: 'Descrizione analisi',
    },
    update: {
      updateLocation: 'Aggiorna sede',
      success: 'Sede associata con successo',
    },
  },
  customersLocationsManagement: {
    title: 'Associazione clienti',
    subtitle: 'Cerca cliente per Codice cliente o Denominazione Sociale',
    noCustomer: 'Seleziona un cliente per vederne i dati e le sedi associate',
    synopsis: {
      title: 'Dati cliente',
      id: 'ID cliente',
      name: 'Denominazione sociale',
      address: 'Indirizzo',
      city: 'Città',
      zip: 'CAP',
      province: 'Provincia',
      countryCode: 'Codice paese',
      countryDescription: 'Paese',
      vat: 'Partita IVA',
      fiscalCode: 'Codice fiscale',
      phoneNumber: 'Telefono',
      email: 'Email',
      isEnabled: 'Abilitato',
      canViewRawData: 'Visibilità dati grezzi',
      creditLimit: 'Fido residuo',
      maxOrder: 'Ordine massimo',
      creditLimitExpirationDate: 'Fine validità fido',
      yes: 'Sì',
      no: 'No',
    },
    search: {
      id: 'Codice cliente',
      name: 'Denominazione sociale',
    },
    create: {
      createAssociation: 'Associa cliente',
      createCustomerLocation: 'Crea associazione',
      lab: 'Laboratorio',
      location: 'Sede',
      abortAction: 'Annulla',
      success: 'Sede associata con successo ',
    },
    update: {
      updateCustomerLocation: 'Aggiorna associazione',
      success: 'Sede associata con successo ',
    },
  },
  customerSampleAnalyses: {
    title: 'Assegnazione sede',
    deafultLocationSettings: 'Impostazioni sede predefinita',
    update: {
      bulkSuccess: 'Analisi aggiornate con successo',
    },
    defaultLocation: {
      title: 'Impostazioni sede predefinita',
      automatic: 'Automatica',
      manual: 'Manuale',
      modality: 'Modalità di assegnazione',
      location: 'Sede',
      laboratory: 'Laboratorio',
      closeUpdate: 'Chiudi',
    },
    hasLocation: {
      toBeAssigned: 'Da assegnare',
      assigned: 'Assegnata',
    },
  },
  familyTypes: {
    title: 'Configurazione template RdP',
    addFamilyType: 'Aggiungi configurazione',
    create: {
      title: 'Crea Configurazione',
      family: 'Famiglia',
      type: 'Tipologia',
      abort: 'Annulla',
      save: 'Crea',
      success: 'Configurazione creata con successo',
    },
    edit: {
      title: 'Modifica Configurazione',
      save: 'Aggiorna',
      success: 'Configurazione modificata con successo',
    },
  },
  familyCategories: {
    title: 'Categorie famiglie',
    intro:
      'Raggruppa le famiglie di analisi in categorie. In MyLab i clienti possono filtrare per categoria i campioni di Stato campioni.',
    familiesCount: 'Nessuna famiglia | 1 famiglia | {count} famiglie',
    empty: 'Nessuna famiglia in questa categoria',
    add: 'Aggiungi famiglia',
    searchPlaceholder: 'Cerca per nome o codice',
    alreadyIn: 'In {category}',
    remove: 'Togli',
    removeConfirm: 'Togliere {family} da {category}?',
    cancel: 'Annulla',
    moveTitle: 'Spostare la famiglia?',
    moveConfirm: '{family} è già in {category}. Spostarla in {target}?',
    move: 'Sposta',
    added: '{family} aggiunta a {category}',
    moved: '{family} spostata in {category}',
    removed: '{family} tolta da {category}',
    newCategory: 'Nuova categoria',
    actions: 'Azioni sulla categoria',
    rename: 'Rinomina',
    delete: 'Elimina',
    deleteTitle: 'Eliminare la categoria?',
    deleteConfirm:
      '{category} sarà eliminata e in MyLab non comparirà più tra i filtri. | {category} sarà eliminata: la sua famiglia resterà senza categoria e in MyLab non comparirà più tra i filtri. | {category} sarà eliminata: le sue {count} famiglie resteranno senza categoria e in MyLab non comparirà più tra i filtri.',
    created: 'Categoria {category} creata',
    renamed: 'Categoria {category} rinominata',
    deleted: 'Categoria {category} eliminata',
    dialog: {
      createTitle: 'Nuova categoria',
      renameTitle: 'Rinomina categoria',
      italian: 'Nome in italiano',
      english: 'Nome in inglese',
      spanish: 'Nome in spagnolo',
      spanishPlaceholder: 'Facoltativo: se vuoto si usa il nome inglese',
      create: 'Crea',
      save: 'Salva',
      duplicate: 'Esiste già una categoria con questo nome',
    },
  },
  stabilityFilter: {
    include: 'Mostra tutto',
    only: 'Mostra solo stabilità',
    exclude: 'Escludi stabilità',
  },
  stability: {
    title: 'Configurazioni Stabilità',
    backToList: 'Torna alla lista',
    name: 'Nome',
    deafultStabilityName: 'Nuova configurazione',
    namePlaceholder: 'Nome configurazione...',
    sampleCode: 'Codice campione',
    customer: 'Cliente',
    token: 'Token',
    temperature: 'Temperatura',
    humidity: 'Umidità',
    matrix: 'Matrice',
    matrixPlaceholder: 'Matrice (facoltativa)',
    includeHumidity: 'Umidità',
    cloneAction: 'Clona',
    confirmConfig: 'Conferma configurazione',
    confirmConfigTitle: 'Conferma configurazione',
    confirmConfigMessage:
      "Questa azione avvierà l'elaborazione dei campioni di stabilità. La configurazione non potrà più essere modificata. Continuare?",
    searchAnalyses: 'Cerca analisi...',
    searchByCode: 'Codice',
    searchByDescription: 'Descrizione',
    matches: {
      add: 'Aggiungi combinazione',
      addTitle: 'Nuova combinazione',
      cloneTitle: 'Clona combinazione',
      toDate: 'Scadenza',
      delete: 'Elimina',
      deleteConfirm:
        'Eliminare la combinazione e tutte le sue analisi? La condizione resta disponibile per le altre combinazioni.',
      empty:
        'Nessuna combinazione. Creane una abbinando un punto temporale a una condizione.',
    },
    timePoints: {
      sectionTitle: 'Punti temporali',
      add: 'Aggiungi punto temporale',
      addTitle: 'Nuovo punto temporale',
      editTitle: 'Modifica punto temporale',
      delete: 'Elimina',
      tokenPlaceholder: 'Es. T0, T3M, T6M',
      description: 'Descrizione',
      descriptionPlaceholder: 'Descrizione (facoltativa)',
      fromDate: 'Data di inizio',
      toDate: 'Data di fine (calcolata)',
      fileTitle: 'Allegati del punto temporale',
      fileNone: 'Nessun file caricato',
      fileUpdatedAt: 'Caricato il',
      fileUpload: 'Carica file',
      fileRemove: 'Rimuovi',
      fileRemoveConfirm: 'Rimuovere il file {name}?',
      fileHint:
        'Sono ammessi solo file .pdf e .xlsx. Ogni caricamento si aggiunge ai file esistenti.',
      fileWrongType: 'Sono ammessi solo file {extensions}.',
      pick: 'Punto temporale',
      matchCount: 'Combinazioni',
      empty:
        'Nessun punto temporale definito. Aggiungine almeno uno per poter creare le combinazioni.',
      defineFirst:
        'Definisci i punti temporali nella sezione qui sopra per poter creare le combinazioni.',
      duplicateToken:
        'Esiste già un punto temporale con questo token in questa configurazione.',
      deleteConfirm: 'Eliminare il punto temporale {token}?',
      deleteWithMatchesConfirm:
        'Il punto temporale {token} è usato da {count} combinazioni: eliminandolo verranno eliminate anche quelle e le analisi ad esse associate. Le condizioni restano disponibili. Continuare?',
    },
    summary: {
      labSample: 'Campione',
      labSampleStatus: 'Stato campione',
      analysisStatus: 'Stato analisi',
      analysis: 'Analisi',
      fromDate: 'Data inizio',
      toDate: 'Data presunta consegna',
    },
    protocol: {
      upload: 'Carica file',
      replace: 'Sostituisci',
      none: 'Nessun protocollo caricato',
      wrongType: 'Il protocollo deve essere un file .pdf.',
    },
    noAnalyses: 'Nessuna analisi',
    labSampleCodes: 'Campioni laboratorio',
    saving: 'Salvataggio...',
    saved: 'Salvato',
    retryExplosion: 'Riprova elaborazione',
    retryQueued: 'Elaborazione riaccodata.',
    banners: {
      processing: {
        title: 'Configurazione in elaborazione',
        description: 'La generazione dei campioni di stabilità è in corso.',
      },
      configured: {
        title: 'Configurazione completata',
        description: 'I campioni di stabilità sono stati generati.',
      },
      error: {
        title: 'Elaborazione non riuscita',
        description:
          "Si è verificato un errore durante la generazione dei campioni di stabilità. Riprova l'elaborazione; se l'errore persiste, contatta l'assistenza.",
      },
    },
    warnings: {
      noTimePointsConfirm:
        'Aggiungi almeno un punto temporale prima di confermare.',
      timePointsWithoutMatch:
        'Uno o più punti temporali non sono usati da nessuna combinazione. Creane almeno una per ciascuno.',
      matchesWithoutAnalysis:
        'Una o più combinazioni non hanno analisi associate. Aggiungine almeno una per ciascuna.',
    },
    meta: {
      name: 'Nome',
      customer: 'Cliente',
      order: 'Ordine',
      docNumber: 'Numero offerta',
      productName: 'Nome prodotto',
      analysisCode: 'Cod. articolo',
      analysisDescription: 'Descrizione',
      status: 'Stato',
      createdAt: 'Creato il',
      configuredAt: 'Configurato il',
      protocol: 'Protocollo',
    },
    errors: {
      generic: 'Si è verificato un errore. Riprova.',
      loadFailed: 'Impossibile caricare la configurazione.',
      listLoadFailed: 'Impossibile caricare la lista delle stabilità.',
      retryFailed: "Impossibile riavviare l'elaborazione.",
      invalidHumidity:
        "L'umidità deve essere un numero intero compreso tra 0 e 100 (%RH)",
    },
    schedule: {
      title: 'Scadenziario',
      pickWeek: 'Seleziona settimana',
      weekFormat: '[Settimana] WW - YYYY',
      loadError: 'Errore nel caricamento dello scadenziario.',
      today: 'Oggi',
      twoWeek: '2 Settimane',
      month: 'Mese',
      notAccepted: 'Campione non ancora accettato',
    },
    timePointExport: {
      title: 'Estrazione T stabilità',
      completedFrom: 'Data completamento T da',
      completedTo: 'Data completamento T a',
      export: 'Esporta Excel',
      loading: 'Estrazione in corso…',
      noResults:
        "Nessun T corrisponde ai filtri impostati. Amplia l'intervallo di date o rimuovi qualche filtro.",
      error: "Errore durante l'estrazione",
      invalidId: '{field}: inserisci un numero intero positivo.',
      unconfirmedFilters:
        'Seleziona un valore dai suggerimenti oppure svuota il campo: {fields}. Il testo libero in questi campi non viene usato come filtro.',
    },
  },
  uploadDocument: {
    title: 'Caricamento PDF da firmare',
    uploadLabel: 'Nome file:',
    successMessage: 'Documento caricato con successo',
  },
  pdfPreviewer: {
    confirmButton: 'Carica documento',
    instructions:
      "Seleziona l'area in cui vuoi posizionare la firma utilizzando il mouse.",
  },
  analysesThermostatsSearch: {
    title: 'Ricerca termostati analisi',
  },
  symbolSearch: {
    title: 'Ricerca medium analisi',
  },
};
